var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.7667 28.6001V51.4C70.7667 55.1333 68.7667 58.6001 65.5334 60.5001L45.7334 71.9334C42.5 73.8001 38.5 73.8001 35.2333 71.9334L15.4333 60.5001C12.1999 58.6334 10.1999 55.1666 10.1999 51.4V28.6001C10.1999 24.8667 12.1999 21.3999 15.4333 19.4999L35.2333 8.06663C38.4666 6.19996 42.4667 6.19996 45.7334 8.06663L65.5334 19.4999C68.7667 21.3999 70.7667 24.8334 70.7667 28.6001Z",
    fill: "#FDD855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 45.8334C39.1333 45.8334 38 44.7 38 43.3334V25.8334C38 24.4667 39.1333 23.3334 40.5 23.3334C41.8667 23.3334 43 24.4667 43 25.8334V43.3334C43 44.7 41.8667 45.8334 40.5 45.8334Z",
    fill: "#FDD855"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 57.5C40.0667 57.5 39.6333 57.3999 39.2333 57.2333C38.8 57.0666 38.4666 56.8334 38.1332 56.5334C37.8332 56.2 37.6 55.8333 37.4 55.4333C37.2333 55.0333 37.1667 54.6 37.1667 54.1666C37.1667 53.3 37.4999 52.4332 38.1332 51.7999C38.4666 51.4999 38.8 51.2667 39.2333 51.1C40.4666 50.5667 41.9334 50.8666 42.8667 51.7999C43.1667 52.1332 43.3999 52.4666 43.5666 52.9C43.7333 53.3 43.8333 53.7333 43.8333 54.1666C43.8333 54.6 43.7333 55.0333 43.5666 55.4333C43.3999 55.8333 43.1667 56.2 42.8667 56.5334C42.2334 57.1667 41.4 57.5 40.5 57.5Z",
    fill: "#FDD855"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.89d3df3bcb5c3a6c6a9bbbe0b1329789.svg";
export { ForwardRef as ReactComponent };